import React, { useState, useEffect } from "react";
import { Menu, Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import "../../css/NavBar.css";
import Logo from "../../assets/minmin.jpg";

const MOBILE_BREAKPOINT = 768;
const SCROLL_THRESHOLD = 50;

const menuItems = [
    { key: "home", label: "Trang Chủ", path: "/" },
    { key: "service", label: "Dịch Vụ", path: "/service" },
    { key: "bangGiaChup", label: "Bảng Giá Chụp", path: "/bangGiaChup" },
    { key: "bangGiaQuay", label: "Bảng Giá Quay", path: "/bangGiaQuay" },
    { key: "bangGiaQuayChup", label: "Bảng Giá Quay + Chụp", path: "/bangGiaQuayChup" },
    // { key: "bangGiaFlycam", label: "Bảng giá Flycam", path: "/bangGiaFlycam" },
    // { key: "videos", label: "Videos", path: "/videos" },
    { key: "contact", label: "Liên Hệ", path: "/contact" },
];

export default function Navbar() {
    const location = useLocation();
    const isHomePage = location.pathname === "/";

    const [isScrolled, setIsScrolled] = useState(
        () => window.scrollY > SCROLL_THRESHOLD || location.pathname !== "/"
    );

    const [visible, setVisible] = useState(false);

    const [isMobile, setIsMobile] = useState(
        () => window.innerWidth <= MOBILE_BREAKPOINT
    );

    // Cập nhật màu navbar khi cuộn và khi chuyển trang
    useEffect(() => {
        const updateNavbar = () => {
            const shouldHaveBackground =
                !isHomePage || window.scrollY > SCROLL_THRESHOLD;

            setIsScrolled(shouldHaveBackground);
        };

        // Chạy ngay khi vào trang hoặc chuyển route
        updateNavbar();

        window.addEventListener("scroll", updateNavbar, {
            passive: true,
        });

        return () => {
            window.removeEventListener("scroll", updateNavbar);
        };
    }, [isHomePage, location.pathname]);

    // Responsive desktop / mobile
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // Đóng drawer khi chuyển trang
    useEffect(() => {
        setVisible(false);
    }, [location.pathname]);

    const showDrawer = () => setVisible(true);
    const closeDrawer = () => setVisible(false);

    const renderMenuItems = () =>
        menuItems.map((item) => ({
            key: item.key,
            label: <Link to={item.path}>{item.label}</Link>,
        }));

    return (
        <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
            {/* LOGO */}
            <div className="logo">
                <Link to="/" className="logo-link">
                    <img
                        src={Logo}
                        alt="MinMin Wedding - Phóng Sự Cưới"
                        className="navbar-logo"
                    />
                    <span>MinMin Wedding - Phóng Sự Cưới</span>
                </Link>
            </div>

            {/* DESKTOP MENU */}
            {!isMobile && (
                <Menu
                    mode="horizontal"
                    className="nav-menu"
                    selectable={false}
                    items={renderMenuItems()}
                />
            )}

            {/* MOBILE BUTTON */}
            {isMobile && (
                <Button
                    className="menu-btn"
                    type="text"
                    icon={<MenuOutlined />}
                    onClick={showDrawer}
                    aria-label="Mở menu"
                />
            )}

            {/* MOBILE DRAWER */}
            <Drawer
                title={
                    <div className="drawer-logo">
                        <img src={Logo} alt="MinMin Wedding - Phóng Sự Cưới" />
                        <span>MinMin Wedding - Phóng Sự Cưới</span>
                    </div>
                }
                placement="right"
                onClose={closeDrawer}
                open={visible}
            >
                <Menu
                    mode="vertical"
                    selectable={false}
                    items={renderMenuItems()}
                    onClick={closeDrawer}
                />
            </Drawer>
        </nav>
    );
}